export const USER_DIALOG_ACTION_TYPES = {
  SHOW_EDIT_ZONE_DIALOG: 'SHOW_EDIT_ZONE_DIALOG',
  HIDE_EDIT_ZONE_DIALOG: 'HIDE_EDIT_ZONE_DIALOG',
  EDIT_ZONE_DIALOG_SAVED: 'EDIT_ZONE_DIALOG_SAVED',
  SHOW_ZONE_DIALOG: 'SHOW_ZONE_DIALOG',
  HIDE_ZONE_DIALOG: 'HIDE_ZONE_DIALOG',
  ZONE_DIALOG_SAVED: 'ZONE_DIALOG_SAVED',
  SHOW_PERSON_NAME_DIALOG: 'SHOW_PERSON_NAME_DIALOG',
  HIDE_PERSON_NAME_DIALOG: 'HIDE_PERSON_NAME_DIALOG',
  PERSON_NAME_DIALOG_SAVED: 'PERSON_NAME_DIALOG_SAVED',
  SHOW_CREDENTIAL_DIALOG: 'SHOW_CREDENTIAL_DIALOG',
  HIDE_CREDENTIAL_DIALOG: 'HIDE_CREDENTIAL_DIALOG',
  CREDENTIAL_DIALOG_SAVED: 'CREDENTIAL_DIALOG_SAVED',
  SHOW_BULLETIN_DIALOG: 'SHOW_BULLETIN_DIALOG',
  HIDE_BULLETIN_DIALOG: 'HIDE_BULLETIN_DIALOG',
  BULLETIN_DIALOG_SAVED: 'BULLETIN_DIALOG_SAVED',
  SHOW_EDIT_VEHICLE_DIALOG: 'SHOW_EDIT_VEHICLE_DIALOG',
  HIDE_EDIT_VEHICLE_DIALOG: 'HIDE_EDIT_VEHICLE_DIALOG',
  VEHICLE_DIALOG_UPDATED: 'VEHICLE_DIALOG_UPDATED',
  SHOW_ADD_VEHICLE_DIALOG: 'SHOW_ADD_VEHICLE_DIALOG',
  HIDE_ADD_VEHICLE_DIALOG: 'HIDE_ADD_VEHICLE_DIALOG',
  VEHICLE_DIALOG_CREATED: 'VEHICLE_DIALOG_CREATED',
  SHOW_ADD_EDIT_PERSON: 'SHOW_ADD_EDIT_PERSON',
  HIDE_ADD_EDIT_PERSON: 'HIDE_ADD_EDIT_PERSON',
  PERSON_SAVED: 'PERSON_SAVED',
  SHOW_ADD_EDIT_PLACE: 'SHOW_ADD_EDIT_PLACE',
  HIDE_ADD_EDIT_PLACE: 'HIDE_ADD_EDIT_PLACE',
  PLACE_SAVED: 'PLACE_SAVED',
  SHOW_ADDRESS_DIALOG: 'SHOW_ADDRESS_DIALOG',
  HIDE_ADDRESS_DIALOG: 'HIDE_ADDRESS_DIALOG',
  ADDRESS_DIALOG_SAVED: 'ADDRESS_DIALOG_SAVED',
  ADDRESS_DIALOG_DELETED: 'ADDRESS_DIALOG_DELETED',
};
